import { render, staticRenderFns } from "./list-request.vue?vue&type=template&id=539866ce&"
import script from "./list-request.vue?vue&type=script&lang=js&"
export * from "./list-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports